package nl.astraeus.midi.view

import nl.astraeus.midi.NoteLength
import nl.astraeus.midi.symbols.createBravura
import nl.astraeus.midi.symbols.createNoteDown
import nl.astraeus.midi.symbols.createNoteUp
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement

data class Symbol(
  val symbol: HTMLCanvasElement,
  val dx: Double = 0.0,
  val dy: Double = 0.0,
)

class Symbols {
  val wholeNoteUp = Symbol(createNoteUp(NoteLength.WHOLE), 0.0, 0.0)
  val halfNoteUp = Symbol(createNoteUp(NoteLength.HALF), 0.0, 0.0)
  val quarterNoteUp = Symbol(createNoteUp(NoteLength.QUARTER), -0.0, -1.5)
  val quarterNoteDown = Symbol(createNoteDown(NoteLength.QUARTER), -0.0, -1.5)
  val eighthNoteUp = Symbol(createNoteUp(NoteLength.EIGHTEENTH), -0.0, -1.5)
  val sixteenthNoteUp = Symbol(createNoteUp(NoteLength.SIXTEENTH), -0.0, -1.5)
  val sharp = Symbol(createBravura("\ue262"), -0.0, -1.5)
  val flat = Symbol(createBravura("\ue260"), -0.0, -1.5)

  val trebleClef = Symbol(createBravura("\uE050"), 0.0, -30.0)
  val bassClef = Symbol(createBravura("\uE062"), 5.0, 20.0)
  val time0 = Symbol(createBravura("\uE080"), 5.0, 20.0)
  val time4 = Symbol(createBravura("\uE084"), 5.0, -50.0)
}

fun CanvasRenderingContext2D.drawSymbol(
  symbol: Symbol,
  x: Double,
  y: Double,
  scaling: Double = 1.0,
) {
  val width = symbol.symbol.width * scaling
  val height = symbol.symbol.height * scaling

  val dx = x - (width / 2)
  val dy = y - (height / 2)

  this.drawImage(
    symbol.symbol,

    0.0, 0.0,
    symbol.symbol.width.toDouble(), symbol.symbol.height.toDouble(),

    dx + symbol.dx * scaling, dy + symbol.dy * scaling,
    symbol.symbol.width.toDouble() * scaling, symbol.symbol.height.toDouble() * scaling
  )
}
